import { render, staticRenderFns } from "./shopCashierDevice.vue?vue&type=template&id=31615e6c&scoped=true&"
import script from "./shopCashierDevice.vue?vue&type=script&lang=js&"
export * from "./shopCashierDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31615e6c",
  null
  
)

export default component.exports